import React, { useMemo } from 'react';
import { SelectOption } from 'global';
import { FormInputSelect } from 'components/form';
import { RemoveCircle } from '@mui/icons-material';
import { IconButton, Box, Tooltip } from '@mui/material';

interface Props {
  listOfFacts: SelectOption[];
  onRemove?: VoidFunction;
  addedCriteriaTypes: string[];
  currentValue: string | undefined;
  onChange: (nextValue: string) => void;
}

export const CriteriaHeadCell = ({ onRemove, onChange, currentValue, addedCriteriaTypes, listOfFacts }: Props) => {
  const options = useMemo(() => {
    const currentOption = listOfFacts.find(fact => fact.value === currentValue);
    const filteredOptions = listOfFacts.filter(({ value }) => !addedCriteriaTypes.includes(value));

    if (currentOption) return [currentOption, ...filteredOptions];

    return filteredOptions;
  }, [addedCriteriaTypes, currentValue, listOfFacts]);

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '2.5rem 1fr', gap: '0.5rem', width: '100%' }}>
      {onRemove && (
        <Tooltip title="Remove configuration">
          <IconButton size="small" onClick={onRemove}>
            <RemoveCircle sx={{ fontSize: 20 }} color="error" />
          </IconButton>
        </Tooltip>
      )}

      <FormInputSelect variant="outlined" size="small" value={currentValue} onChange={onChange} options={options} />
    </Box>
  );
};
